import React, { useRef } from 'react';
import { motion, useMotionTemplate, useMotionValue } from 'framer-motion';

export default function SpotlightCard({ children, className = "", innerClassName = "", radius = "2.5rem" }) {
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);

  function handleMouseMove({ currentTarget, clientX, clientY }) {
    let { left, top } = currentTarget.getBoundingClientRect();
    mouseX.set(clientX - left);
    mouseY.set(clientY - top);
  }

  // Calculate inner radius slightly smaller than outer radius
  const outerRadius = radius;
  const innerRadius = `calc(${radius} - 2px)`;

  return (
    <div
      onMouseMove={handleMouseMove}
      className={`group relative bg-foreground/5 p-px overflow-hidden ${className}`}
      style={{ borderRadius: outerRadius }}
    >
      <motion.div
        className="pointer-events-none absolute -inset-px opacity-0 transition duration-300 group-hover:opacity-100"
        style={{
          borderRadius: outerRadius,
          background: useMotionTemplate`
            radial-gradient(
              350px circle at ${mouseX}px ${mouseY}px,
              rgba(234, 88, 12, 0.4),
              rgba(30, 110, 255, 0.4),
              transparent 80%
            )
          `,
        }}
      />
      <div 
        className={`relative h-full w-full bg-background ${innerClassName}`}
        style={{ borderRadius: innerRadius }}
      >
        {children}
      </div>
    </div>
  );
}
